import React, { Fragment } from 'react';
import { withFormik, Field } from 'formik';
import { Button, ModalBody, ModalFooter } from 'reactstrap';
import * as yup from 'yup';

import { MIN_STRING_LENGTH } from 'helpers/constants';
import InputFeedback from '../InputFeedback';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';

const ContactUsModalFormSchema = yup.object().shape({
  message: yup
    .string()
    .min(
      MIN_STRING_LENGTH,
      `Message has to be longer than ${MIN_STRING_LENGTH} characters!`,
    )
    .required("message can't be empty"),
});

const ContactUsModalForm = ({
  isSubmitting,
  handleSubmit,
  isValid,
  touched,
  errors,
}) => {
  return (
    <Fragment>
      <ModalBody>
        <div className="contact-us">
          <div className="contact-us__content">
            <div className="feedback__row mt-3">
              <div className="feedback__field">
                <label className="h2-title">How we can help?</label>
                <Field
                  name="message"
                  render={({ field }) => (
                    <textarea
                      rows={7}
                      className="feedback__textarea"
                      {...field}
                    />
                  )}
                />
                <InputFeedback error={touched.message && errors.message} />
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="btn btn-blue big"
          onClick={handleSubmit}
          disabled={!isValid || isSubmitting}>
          {isSubmitting ? 'Loading' : 'Submit'}
        </Button>
      </ModalFooter>
    </Fragment>
  );
};

export default withFormik({
  mapPropsToValues: () => ({
    message: '',
  }),
  isInitialValid: false,
  validationSchema: ContactUsModalFormSchema,
  handleSubmit: async (
    values,
    { props, setSubmitting, setErrors, resetForm },
  ) => {
    await props.handleSubmit(values, setSubmitting, setErrors, resetForm);
  },
})(ContactUsModalForm);



// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUsModalForm.js